import React,{Component} from 'react';
import './App.css';
import {HashRouter,Switch,Route} from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
// import Login from "./userinterface/Login";
import {BLUE_COLOR, PINK_COLOR, RED_COLOR} from "./constants";
import SearchPage from "./userinterface/SearchPage";
import Maintenance from "./userinterface/MTNSSTMVLS";
import MTNS1 from "./userinterface/MTNSBCP14Feb";
import ClientList from "./userinterface/ClientList";
import ViewPendingRequest from "./userinterface/ViewPendingRequest";
import BatchPage from "./userinterface/BatchPage";
import CddPage from "./userinterface/CDDCRM";
import CRPPage from "./userinterface/ClientRskProfile";
import EXPIREPage from "./userinterface/ExpireCdd";
import {Page404} from "./components/Page404";
import reducers from './reducers';
import SalesPage from "./userinterface/SalesScreen";
import ABDPage from "./userinterface/ActisureBankDetails";
import {createStore,applyMiddleware} from 'redux';  
import {Provider} from 'react-redux';
import ReduxThunk from 'redux-thunk';
import Login from './userinterface/Login';
import ReactSession from 'react-client-session';
import MaturitiesPage from "./userinterface/Maturities";
import IFRS17DataFiles from "./userinterface/IFRS17DataFiles";
import TabPage from "./userinterface/CMS";
import Commonmail from "./userinterface/Commonmail";
import CDDKYC from "./userinterface/CDDKYC.js"

const THEME = createMuiTheme({
    palette: {
        primary: {
            main: BLUE_COLOR,
        },
        secondary: {
            main: PINK_COLOR,
        },
        error:{
            main:RED_COLOR
        },
        info:{
            main:"#C0C0C0"
        }
    },
    typography: {
        "fontFamily": `"Globerregular", "Globersemibold", "Globerbold", sans-serif`,
        "fontSize": 14,
        "fontWeightLight": 300,
        "fontWeightRegular": 400,
        "fontWeightMedium": 500
    }

});
export default class App extends Component{
  render() {
    const store = createStore(reducers,{},applyMiddleware(ReduxThunk));
    return (
      <Provider store={store}>
        <MuiThemeProvider theme={THEME}>
            <HashRouter>
                <Switch>
                    
                    <Route exact path={'/'}>
                        <Login/>
                    </Route>
                    <Route exact path={'/CDD'}>
                        <CddPage/>
                    </Route>
                    <Route exact path={'/CRP'}>
                        <CRPPage/>
                    </Route>
                     <Route exact path={'/EXPIRE'}>
                        <EXPIREPage/>
                    </Route>
                    <Route exact path={'/AML'}>
                        <SearchPage/>
                    </Route>
                    <Route exact path={'/ABD'}>
                        <ABDPage/>
                    </Route>
                    <Route exact path={'/BATCH'}>
                        <BatchPage/>
                    </Route>
                    <Route exact path={'/CML'}>
                        <Commonmail/>
                    </Route>
                    {/* <Route exact path={'/Maintenance'}>
                        <Maintenance/>
                     </Route> */}
                        {/* <Route exact path={'/ClientList'}>
                        <ClientList/>
                     </Route> */}
                     <Route exact path={'/SPS'}>
                        <SalesPage/>
                    </Route>
                    <Route exact path={'/view_pending_requests'}>
                        <ViewPendingRequest/>
                    </Route>
                      {/* <Route exact path={'/MLP'}>
                        <MaturitiesPage/>
                    </Route> */}
                    {/* <Route exact path={'/CMS'}>
                        <TabPage/>
                    </Route> */}
                     <Route exact path={'/MTNS1'}>
                        <MTNS1/>
                     </Route>
                     <Route exact path={'/IFRS'}>
                        <IFRS17DataFiles/>
                     </Route>
                     <Route exact path={'/CDDKYC'}>
                        <CDDKYC/>
                        </Route> 
                      <Route path={'*'}>
                    <Page404
                    h3text ='Sorry, Error 404 page not found !'
                    txtsecondary='Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL?
                    Be sure to check your spelling.'
                    bgcolor='cadetblue'
                    />
                    </Route>
                </Switch>
            </HashRouter>
        </MuiThemeProvider>
      </Provider>
    );
  }
}
